import {
  PRE_SUGGESTED_VIDEOS,
  SUGGESTED_VIDEOS_SUCCESS,
  MORE_SUGGESTED_VIDEOS,
  GETTING_MORE_SUGGESTED_VIDEOS
} from "./actionTypes";
import changeKey from "./keyAction";
import { gettingDetails } from "./detailsAction";
import yangAxios from "../YangAxios";

export const getSuggestedVideo = (id, params = "") => {
  return async (dispatch, getStore) => {
    if (params) dispatch(gettingMoreSuggestedVideos(true));
    const keys = getStore().apiKey.keys;
    let index = getStore().apiKey.currentKey;
    try {
      const res = await yangAxios.get(
        `search?part=snippet&maxResults=15${params}&relatedToVideoId=${id}&type=video&key=${
          keys[index]
        }`
      );
      const data = res.data;
      data.items.forEach((item, i) => {
        dispatch(gettingDetails(item.id.videoId, i, "suggestion"));
      });
      if (params === "") dispatch(gotSuggestedVideos(data));
      else if (params.indexOf("&pageToken=") !== -1)
        dispatch(gotMoreSuggestedVideos(data));
    } catch (err) {
      if (index < keys.length && err.response && err.response.status === 403) {
        index++;
        dispatch(changeKey(index));
        dispatch(getSuggestedVideo(id, params));
        return;
      }
      console.log(err);
    }
    if (params) dispatch(gettingMoreSuggestedVideos(false));
  };
};

export const gotMoreSuggestedVideos = data => {
  return {
    type: MORE_SUGGESTED_VIDEOS,
    payload: data
  };
};

export const gotSuggestedVideos = data => {
  return {
    type: SUGGESTED_VIDEOS_SUCCESS,
    payload: data
  };
};

export const preSuggestedVideos = data => {
  return {
    type: PRE_SUGGESTED_VIDEOS,
    payload: data
  };
};

const gettingMoreSuggestedVideos = val => {
  return {
    type: GETTING_MORE_SUGGESTED_VIDEOS,
    payload: val
  };
};
